const todayIso = () => new Date().toISOString().split('T')[0];

export const formatMonthYear = (isoDate) =>
    new Intl.DateTimeFormat(undefined, {year: 'numeric', month: 'short'})
        .format(new Date(isoDate + 'T00:00:00'));

export const formatDuration = (fromIso, toIso) => {
    if (!fromIso) return null;

    const start = new Date(fromIso + 'T00:00:00');
    const end   = new Date((toIso ?? todayIso()) + 'T00:00:00');

    const days = Math.round((end - start) / 86_400_000);
    if (days < 0) return null;
    if (days < 31) return days === 1 ? '1 day' : `${days} days`;

    let years  = end.getFullYear() - start.getFullYear();
    let months = end.getMonth()    - start.getMonth();
    if (months < 0) { years--; months += 12; }

    const y = years  === 1 ? '1 year'  : years  > 1 ? `${years} years`   : null;
    const m = months === 1 ? '1 month' : months > 1 ? `${months} months` : null;

    return [y, m].filter(Boolean).join(' ') || '1 month';
};

export const formatPeriod = (fromIso, toIso) => {
    if (!fromIso) return null;
    const duration = formatDuration(fromIso, toIso);
    const start = formatMonthYear(fromIso);
    const end   = toIso ? formatMonthYear(toIso) : 'present';
    return duration ? `${start} – ${end} · ${duration}` : `${start} – ${end}`;
};